import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var ProjectEdit =
/*#__PURE__*/
function () {
  function ProjectEdit() {
    _classCallCheck(this, ProjectEdit);
  }

  _createClass(ProjectEdit, [{
    key: "GetAllRents",
    value: function () {
      var _GetAllRents = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(projectId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("api/projects/GetProjectAllRents/".concat(projectId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetAllRents(_x) {
        return _GetAllRents.apply(this, arguments);
      }

      return GetAllRents;
    }()
  }, {
    key: "GetCurrentRents",
    value: function () {
      var _GetCurrentRents = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(projectId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("api/projects/GetProjectCurrentRents/".concat(projectId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetCurrentRents(_x2) {
        return _GetCurrentRents.apply(this, arguments);
      }

      return GetCurrentRents;
    }()
  }, {
    key: "GetProjectListQuery",
    value: function () {
      var _GetProjectListQuery = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectInfo) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.post("api/projects/GetProjectListQuery", projectInfo));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetProjectListQuery(_x3) {
        return _GetProjectListQuery.apply(this, arguments);
      }

      return GetProjectListQuery;
    }()
  }, {
    key: "GetProjectObject",
    value: function () {
      var _GetProjectObject = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("api/projects/GetProjectObject"));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function GetProjectObject() {
        return _GetProjectObject.apply(this, arguments);
      }

      return GetProjectObject;
    }()
  }, {
    key: "GetItemStatus",
    value: function () {
      var _GetItemStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(projectId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("api/projects/GetItemStatus/".concat(projectId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function GetItemStatus(_x4) {
        return _GetItemStatus.apply(this, arguments);
      }

      return GetItemStatus;
    }()
  }]);

  return ProjectEdit;
}();

export default new ProjectEdit();